const headers = new Headers();
headers.append('Content-Type', 'application/json');
headers.append('Accept', 'text/plain');

export default headers;
